"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var KnowledgeBaseFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_KnowledgeBaseFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5a1.5 1.5 0 0 1 1-1.415V.064C3.17.483 1 2.912 1 5.847c0 .219.015.437.044.653H5.5a1 1 0 0 1 1 1v3.585a1.5 1.5 0 1 1-1 0V7.5H1.29c.065.181.141.359.228.532l.414.825c.38.755.61 1.575.68 2.416l.349 4.162c.027.32.294.565.616.565h5.491c.241 0 .423-.22.375-.456a1.527 1.527 0 0 1 1.67-1.814l.766.085a1.504 1.504 0 0 0 1.672-1.49v-2.21a.17.17 0 0 1 .107-.158l.485-.193a1.354 1.354 0 0 0 .458-2.219l-.644-.64a1.994 1.994 0 0 1-.535-.963l-.103-.442H11v1.585a1.5 1.5 0 1 1-1 0V5.5a1 1 0 0 1 1-1h2.082A6.148 6.148 0 0 0 7.152 0H7v2.085A1.5 1.5 0 1 1 5 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM6 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM10.5 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_KnowledgeBaseFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = KnowledgeBaseFill;
exports["default"] = _default;